var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0099 14.96C11.0999 14.96 10.3599 14.2 10.3599 13.26V10.72C10.3599 9.78002 11.0999 9.02002 12.0099 9.02002C12.9199 9.02002 13.6599 9.78002 13.6599 10.72V13.26C13.6599 14.2 12.9199 14.96 12.0099 14.96Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.99 13.51C16.79 16.16 14.63 18.24 12.01 18.24C9.25001 18.24 7.01001 15.94 7.01001 13.1V10.9C7.01001 8.06001 9.25001 5.76001 12.01 5.76001C14.6 5.76001 16.73 7.79002 16.98 10.38",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.32001 7.22C6.56001 4.72 9.1 3 12 3C16.12 3 19.5 6.47001 19.5 10.71V13.28C19.5 17.52 16.13 20.99 12 20.99C7.88 20.99 4.5 17.52 4.5 13.28V10.71",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetection);
export default __webpack_public_path__ + "static/media/detection.059059f2f37c6be4797f46050ee48294.svg";
export { ForwardRef as ReactComponent };